//import { Grid, Paper, Typography } from '@material-ui/core';
import { Fragment, useEffect, useState, useLayoutEffect } from 'react';
import ApplicationsApi from '../../services/applications'
import ApartmentsApi from '../../services/apartments'
import UsersApi from '../../services/users'
//import { BeforeLoginStepProps } from '../Apartment/BeforeLoginStepper/BeforeLoginStepper'
// import { useState } from 'react'
// import NextStepButton from '../Apartment/BeforeLoginStepper/NextStepButton';
// import { History } from 'history';
// import { AddShowingsFormData } from '../../types/showings';
// import { BaseFormStepProps } from '../../types/instant-rent';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles'
import {
    Grid,
    Typography,
    CircularProgress,
    FormControlLabel,
    Checkbox
} from '@material-ui/core'
//import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { paymentStyles } from '../../styles/paymentStyles'
import { apartmentStyles } from '../../styles/apartmentStyles'
import { Apartment, ApartmentStatus } from '../../types/apartments'
import { useTranslation } from 'react-i18next'
//import { NotifyPaymentStatus } from '../../components/Messages/NotifyPaymentStatus';
import { useDispatch } from 'react-redux';
import { navigate } from '../../actions/routes'
import './Payment.css';
import ContractAndPenIcon from '../../images/paymentPage/contractAndPen.svg'
import CreditCardIcon from '../../images/paymentPage/creditCard.svg'
import HotlineIcon from '../../images/paymentPage/hotline.svg'
import HouseSearchIcon from '../../images/paymentPage/houseSearch.svg'
import SigningContractIcon from '../../images/paymentPage/signingContract.svg'

const useStylesCombined = makeStyles((theme) => ({
    ...paymentStyles(theme),
    ...apartmentStyles(theme),
}));

const Payment = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const classes = useStylesCombined();
    //const [paymentProviders, setPaymentProviders] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [isInMarketing, setIsInMarketing] = useState(false);
    const [isInCreated, setIsInCreated] = useState(false);
    // const [couponCode, setCouponCode] = useState('');
    // const [purchasePriceInCents, setPurchasePriceInCents] = useState(8500);
    // const [couponErrorMessage, setCouponErrorMessage] = useState<string | null>(null);
    // const [couponSuccessMessage, setCouponSuccessMessage] = useState<string | null>(null);
    // const [couponApplied, setCouponApplied] = useState(false);
    // const [showPaymentMethods, setShowPaymentMethods] = useState(true);
    const { apartmentId, userId } = useParams<RouteParams>();
    const [isChecked, setIsChecked] = useState(false);
    const [showCheckboxError, setShowCheckboxError] = useState(false);
    type RouteParams = {
        apartmentId: string;  // or number if you expect a number
        userId: string;       // same here
    };

    // useEffect(() => {
    //     NotifyPaymentStatus({
    //         locationSearch: location.search,
    //         t
    //     });
    // }, [location.search]);
    // useEffect(() => {
    //     if (purchasePriceInCents > 0) {
    //         rentalPaymentHandler();
    //     }
    // }, [purchasePriceInCents]);

    // async function rentalPaymentHandler() {
    //     try {
    //         // You may want to start a loading state here
    //         // setLoading(true);
    //         setIsLoading(true);

    //         // Fetch the apartment data
    //         const apartment: Apartment = await ApartmentsApi.getApartment(userId, apartmentId);

    //         if (!apartment) {
    //             // Handle error appropriately here
    //             return; // You can return here if you don't want to proceed further in case of an error
    //         }

    //         if (apartment.status == ApartmentStatus.marketing) {
    //             setIsInMarketing(true);
    //             setIsLoading(false);
    //             return;
    //         }

    //         if (apartment.status == ApartmentStatus.created) {
    //             setIsInCreated(true);
    //             setIsLoading(false);
    //             return;
    //         }
    //         // if (!apartment.payment || apartment.payment.status !== "ok") {

    //         const apartmentCode = apartment.code;

    //         const apartmentInfo = {
    //             userId,
    //             apartmentId,
    //             apartmentCode,
    //             publishCostInCents: purchasePriceInCents,
    //             ...(couponApplied ? { couponCode } : {})
    //         };

    //         // Initiate payment
    //         const paymentResponse = await ApplicationsApi.initiatePaymentForPublish({ apartmentInfo });

    //         if (paymentResponse) {
    //             setPaymentProviders(paymentResponse);
    //         } else {
    //             setPaymentProviders(null);
    //         }

    //         setIsLoading(false);


    //     } catch (error) {
    //     }
    // }

    useEffect(() => {
        paymentPageHandler();
    }, []);

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, [location.pathname])

    async function paymentPageHandler() {
        try {
            // You may want to start a loading state here
            // setLoading(true);
            //setIsLoading(true);

            // Fetch the apartment data
            const apartment: Apartment = await ApartmentsApi.getApartment(userId, apartmentId);

            if (!apartment) {
                // Handle error appropriately here
                return; // You can return here if you don't want to proceed further in case of an error
            }

            if (apartment.status == ApartmentStatus.marketing) {
                setIsInMarketing(true);
                setIsLoading(false);
                return;
            }

            if (apartment.status == ApartmentStatus.created) {
                setIsInCreated(true);
                setIsLoading(false);
                return;
            }

            //setIsLoading(false);
        } catch (error) {
        }
    }

    // async function handleCoupon(couponCode: string) {
    //     // Reset messages when attempting again
    //     setIsLoading(true);
    //     setCouponErrorMessage(null);
    //     setCouponSuccessMessage(null);

    //     if (couponCode.length < 4) {
    //         setCouponErrorMessage(t('paymentPage.couponCodeTooShort'));
    //         setIsLoading(false);
    //         return;
    //     }

    //     try {
    //         const couponResponse = await ApplicationsApi.handlePaymentCoupon(couponCode, userId);

    //         if (couponResponse && couponResponse.status === 'valid') {
    //             const discount = couponResponse.discountPercentage / 100;
    //             const newPrice = purchasePriceInCents * (1 - discount);
    //             setCouponApplied(true);
    //             setPurchasePriceInCents(newPrice);
    //             setCouponSuccessMessage(t('paymentPage.couponAppliedSuccessfully')); // New message for successful coupon application

    //             if (newPrice <= 0) {
    //                 setShowPaymentMethods(false);
    //             } else {
    //                 setShowPaymentMethods(true);
    //                 //rentalPaymentHandler();  // Call the function to reinitialize the payment methods with the new price
    //             }
    //         } else if (couponResponse && couponResponse.status === 'failed') {
    //             if (couponResponse.message === 'Coupon not found') {
    //                 setCouponErrorMessage(t('paymentPage.couponNotFound'));
    //             } else if (couponResponse.message === 'Coupon has expired') {
    //                 setCouponErrorMessage(t('paymentPage.couponExpired'));
    //             } else if (couponResponse.message === 'Coupon already used') {
    //                 setCouponErrorMessage(t('paymentPage.couponAlreadyUsed'));
    //             } else {
    //                 // Handle other unexpected messages
    //                 setCouponErrorMessage(t('paymentPage.couponNotFound'));
    //             }
    //         }
    //     } catch (error) {
    //     } finally {
    //         setIsLoading(false);
    //     }
    // }

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };
    async function plainPublishFunction() {
        // Reset messages when attempting again
        if (!isChecked) {
            setShowCheckboxError(true); // Show error if button is clicked without checking
        } else {
            setIsLoading(true);
            setShowCheckboxError(false);
            try {
                const status = ApartmentStatus.marketing;

                await ApartmentsApi.updateStatus(
                    userId,
                    apartmentId,
                    { status }
                );
                dispatch(navigate(`/apartments?status=ok`));
                //window.location.reload();
                // if (apartment.status == ApartmentStatus.marketing && couponCode) {
                //     const coupons: { couponCode: string } = {
                //         couponCode
                //     };
                //     try {
                //         const response = await UsersApi.updateUserUsedCoupons(userId, coupons)
                //         dispatch(navigate(`/apartments?status=ok`));
                //     } catch (error) {
                //         console.log(error);
                //     }
                // } else {
                // }
            } catch (error) {
            }
            setIsLoading(false);
        }
    }
    return (
        <Fragment>
            <div className="container">
                <div className="column column1">
                    <h2 className="main-header">{t('paymentPage.disclaimerPageHeader')}</h2>
                    <div className="textitem">
                        <img src={HouseSearchIcon} alt="Apartment Building" />
                        <div className="adjust-text">
                            <p><strong>{t('paymentPage.disclaimer1Header')}.</strong> {t('paymentPage.disclaimer1Text')}.</p>
                        </div>
                    </div>
                    <div className="textitem">
                        <img src={SigningContractIcon} alt="Apartment Building" />
                        <div className="adjust-text">
                            <p><strong>{t('paymentPage.disclaimer2Header')}.</strong> {t('paymentPage.disclaimer2Text')}.</p>
                        </div>
                    </div>
                    <div className="textitem">
                        <img src={CreditCardIcon} alt="Apartment Building" />
                        <div className="adjust-text">
                            <p><strong>{t('paymentPage.disclaimer3Header')}.</strong> {t('paymentPage.disclaimer3Text')}.</p>
                        </div>
                    </div>
                    <div className="textitem">
                        <img src={ContractAndPenIcon} alt="Apartment Building" />
                        <div className="adjust-text">
                            <p><strong>{t('paymentPage.disclaimer4Header')}.</strong> {t('paymentPage.disclaimer4Text')}.</p>
                        </div>
                    </div>
                    <div className="textitem">
                        <img src={HotlineIcon} alt="Apartment Building" />
                        <div>
                            <p><strong>{t('paymentPage.disclaimer5Header')}.</strong> {t('paymentPage.disclaimer5Text')}.</p>
                        </div>
                    </div>
                    {/* Repeat for the remaining items */}
                </div>
                <div className="column column2">
                    <Grid container direction='row' justify='space-evenly'>
                        <Grid container>
                            <Grid item xs={12}>
                                {/* <Typography
                                variant='h4'
                                className={`${classes.centeredText} ${classes.heading
                                    } ${isMobile ? classes.my6 : classes.my8}`}
                            > */}
                                {(!isInMarketing && !isInCreated) ? (
                                    <div >
                                        {/* <Typography
                                            variant='h4'
                                            className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                        >
                                            {t('paymentPage.choosePaymentMethod')}
                                        </Typography> */}
                                        {/* <h2 className="additionalMarginTopMd"> {t('paymentPage.choosePaymentMethod')}</h2> */}
                                        <h2 className="additionalMarginTopMd"> {t('paymentPage.paymentTerms')}</h2>
                                    </div>
                                ) : null}
                            </Grid>
                            {!isLoading ? (
                                !isInMarketing && !isInCreated ? (

                                    // showPaymentMethods ? (
                                    //     <div>
                                    //         {paymentProviders !== undefined && paymentProviders ? (
                                    //             <>
                                    //                 <Grid container spacing={2} alignItems="center" className="gridContainer">
                                    //                     <Grid item xs={12} md={6}>
                                    //                         <div className="price-container">
                                    //                             <Typography
                                    //                                 variant='h5'
                                    //                                 className={`centered-text heading my8`}
                                    //                                 style={{ marginBottom: '4px', marginRight: '10px', fontFamily: 'CircularRegular' }}
                                    //                             >
                                    //                                 {t('paymentPage.price')}:
                                    //                             </Typography>
                                    //                             <Typography
                                    //                                 variant='h4'
                                    //                                 className={`centered-text heading my8 price-text`}
                                    //                                 style={{
                                    //                                     fontFamily: 'CircularRegular',
                                    //                                     fontSize: '30px'
                                    //                                 }}
                                    //                             >
                                    //                                 {`${(purchasePriceInCents / 100).toLocaleString('fi-FI', { style: 'currency', currency: 'EUR' })}`}
                                    //                             </Typography>
                                    //                         </div>
                                    //                     </Grid>
                                    //                     <Grid item xs={12} md={6}>
                                    //                         {!couponApplied && (
                                    //                             <form
                                    //                                 className={`couponForm`}
                                    //                                 onSubmit={(event) => {
                                    //                                     event.preventDefault();
                                    //                                     // Handle coupon validation here.
                                    //                                     handleCoupon(couponCode);
                                    //                                 }}
                                    //                             >
                                    //                                 <input
                                    //                                     type="text"
                                    //                                     placeholder={t('paymentPage.insertCouponCode')}
                                    //                                     onChange={(e) => {
                                    //                                         setCouponCode(e.target.value);
                                    //                                     }}
                                    //                                     className={`couponInput`}
                                    //                                     style={{
                                    //                                         // width: 'calc(100% - 170px)',

                                    //                                     }}
                                    //                                 />
                                    //                                 <Button type="submit" variant="contained" color="primary" className={`couponButton`}
                                    //                                     style={{
                                    //                                         height: '3.05rem',
                                    //                                         paddingLeft: '25px',
                                    //                                         paddingRight: '25px',
                                    //                                     }}>
                                    //                                     {t('paymentPage.applyCoupon')}
                                    //                                 </Button>
                                    //                             </form>
                                    //                         )}
                                    //                         {couponErrorMessage && (
                                    //                             <Typography
                                    //                                 variant='body1'
                                    //                                 className={`couponForm errorText couponMessage`}
                                    //                             >
                                    //                                 {couponErrorMessage}
                                    //                             </Typography>
                                    //                         )}
                                    //                         {couponSuccessMessage && (
                                    //                             <Typography
                                    //                                 variant='body1'
                                    //                                 className={`couponForm successText couponMessage`}
                                    //                             >
                                    //                                 {couponSuccessMessage}
                                    //                             </Typography>
                                    //                         )}
                                    //                     </Grid>
                                    //                 </Grid>
                                    //                 {/* End of coupon form */}
                                    //                 {/* <Typography
                                    //                     variant='h5'
                                    //                     className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                    //                     style={{ marginBottom: '10px' }}
                                    //                 >
                                    //                     {t('paymentPage.choosePaymentMethod')}
                                    //                 </Typography> */}
                                    //                 <div className={classes.paymentOption}>
                                    //                     {paymentProviders.providers.map((provider: any) => (
                                    //                         <form
                                    //                             method='POST'
                                    //                             action={provider.url}
                                    //                             key={provider.id}
                                    //                             className={classes.paymentCard}
                                    //                             onSubmit={(event) => {
                                    //                                 event.preventDefault()
                                    //                                 event.currentTarget.submit()
                                    //                             }}
                                    //                         >
                                    //                             {provider.parameters.map(
                                    //                                 (param: {
                                    //                                     name: string | undefined
                                    //                                     value:
                                    //                                     | string
                                    //                                     | number
                                    //                                     | readonly string[]
                                    //                                     | undefined
                                    //                                 }) => (
                                    //                                     <input
                                    //                                         key={param.name}
                                    //                                         type='hidden'
                                    //                                         name={param.name}
                                    //                                         value={param.value}
                                    //                                     />
                                    //                                 )
                                    //                             )}
                                    //                             <button className="paymentProvider">
                                    //                                 <img
                                    //                                     style={{
                                    //                                         objectFit: 'contain',
                                    //                                         width: '80%'
                                    //                                     }}
                                    //                                     src={provider.svg}
                                    //                                     alt={provider.value}
                                    //                                 />
                                    //                             </button>
                                    //                         </form>
                                    //                     ))}
                                    //                 </div>
                                    //                 <Typography
                                    //                     variant='body1'
                                    //                     className="paymentTermsDisclaimer"
                                    //                 >
                                    //                     <pre className='MuiTypography-root MuiTypography-body1'>
                                    //                         {t('paymentPage.paymentTermsDisclaimerTextPart')}{' '}
                                    //                         <a
                                    //                             style={{ color: '#4f9b44', textDecoration: 'none', fontWeight: 'bold' }}
                                    //                             href='https://www.fiksuvuokraus.fi/kayttoehdot'
                                    //                             target='_blank'
                                    //                             rel='noreferrer'
                                    //                         >
                                    //                             {t('paymentPage.paymentTermsDisclaimerLinkPart')}
                                    //                         </a>
                                    //                     </pre>
                                    //                 </Typography>
                                    //             </>
                                    //         ) : (
                                    //             <Grid item xs={12}>
                                    //                 {/* <Typography
                                    //     variant='h5'
                                    //     className={`${classes.centeredText} ${classes.heading
                                    //         } ${isMobile ? classes.my6 : classes.my8}`}
                                    // >
                                    //     {t('general.notAvailable')}
                                    // </Typography> */}
                                    //                 <Typography
                                    //                     variant='h5'
                                    //                     className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                    //                 >
                                    //                     {t('paymentPage.paymentProvidersNotFound')}
                                    //                 </Typography>
                                    //             </Grid>
                                    //         )}
                                    //     </div>
                                    // ) : (
                                    //     <>
                                    //         <div style={{ width: '100%' }} className={`${classes.centeredText} ${classes.my6}`} >
                                    //             {couponSuccessMessage && (
                                    //                 <Typography
                                    //                     variant='body1'
                                    //                     className={`${classes.centeredText} ${classes.my6}`}
                                    //                     style={{ color: 'green', width: '100%', marginTop: '5px' }}
                                    //                 >
                                    //                     {couponSuccessMessage}
                                    //                 </Typography>

                                    //             )}

                                    //             <Button
                                    //                 onClick={plainPublishFunction}
                                    //                 variant="contained"
                                    //                 color="primary"
                                    //                 className={`${classes.centeredText}`}
                                    //             >
                                    //                 {t('paymentPage.publish')}
                                    //             </Button>
                                    //         </div>
                                    //     </>
                                    // )
                                    <div>
                                        <Grid container className={classes.clauseFormContainer} style={{ display: 'flex', justifyContent: 'center' }}>
                                            <Grid item xs={12} className={classes.clauseFormContainerGrey}>
                                                <div>
                                                    <h2 className={classes.boldFont}>1. {t('paymentPage.clause1Header')}</h2>
                                                    <p>{t('paymentPage.clause1')}</p>
                                                    <h2 className={classes.boldFontWithMargin}>2. {t('paymentPage.clause2Header')}</h2>
                                                    <p>{t('paymentPage.clause2')}</p>
                                                    <h2 className={classes.boldFontWithMargin}>3. {t('paymentPage.clause3Header')}</h2>
                                                    <p>{t('paymentPage.clause3')}</p>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '22px' }}>
                                                <FormControlLabel
                                                    control={<Checkbox checked={isChecked} onChange={handleCheckboxChange} color="primary" style={{
                                                        transform: "scale(1.2)",
                                                    }} />}
                                                    label={<>
                                                        {t('paymentPage.acknowledgeTerms.part1')}{" "}
                                                        <a href="https://fiksuvuokraus.fi/kayttoehdot" style={{ color: "#4f9b44" }} target="_blank">
                                                            {t('paymentPage.acknowledgeTerms.linkText')}
                                                        </a>{" "}
                                                        {t('paymentPage.acknowledgeTerms.part2')}
                                                    </>}
                                                    style={{ marginLeft: '-10px' }}
                                                />
                                                {showCheckboxError && (
                                                    <Typography color="error" style={{ marginTop: '8px' }}>
                                                        {t('paymentPage.checkboxErrorMessage')}
                                                    </Typography>
                                                )}
                                            </Grid>
                                            <Button
                                                onClick={plainPublishFunction}
                                                variant="contained"
                                                color="primary"
                                                className={`${classes.centeredText} ${classes.publishButton}`}
                                            >
                                                {t('paymentPage.publish')}
                                            </Button>
                                        </Grid>
                                    </div>
                                ) : (
                                    <Typography
                                        variant='h4'
                                        className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                        style={{ marginBottom: '10px', width: '100%' }}
                                    >
                                        {isInMarketing ? t('paymentPage.alreadyInMarketing') : t('paymentPage.isUnfinished')}
                                    </Typography>
                                )) : (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: '100%'
                                }}>
                                    <CircularProgress
                                        size={72}
                                        style={{ color: '#4f9b44', margin: '25px' }}
                                    />
                                </div>
                            )}

                        </Grid>
                        {/* <Grid container className={classes.buttonContainer}>
                        <NextStepButton
                            type='button'
                            beforeLogin={beforeLogin}
                            setIsEmpty={setIsEmpty}
                            toValidate={{
                                buildingType: buildingInfo.buildingType
                            }}
                        />
                    </Grid> */}
                    </Grid>
                </div>
            </div>
        </Fragment >
    );
};

//export default withTranslation(Payment as any)
export default Payment
